import cardTypeApi from '../../../api/card-type.api';
import * as constants from '../../../constants';

function getState() {
  return {
    items: [],
    status: constants.RESOURCE_STATUS_NOT_LOADED,
  }
}

const state = getState();

// getters
const getters = {};

// actions
const actions = {
  fetch({commit}) {
    commit('SET_STATUS', constants.RESOURCE_STATUS_LOADING);

    return cardTypeApi.all().then(({data}) => {
      commit('SET_ITEMS', data.data);
    }).finally(() => {
      commit('SET_STATUS', constants.RESOURCE_STATUS_LOADED);
    });
  },
};

// mutations
const mutations = {
  SET_ITEMS(state, items) {
    state.items = items;
  },
  SET_STATUS(state, value) {
    state.status = value;
  },
  ADD_ITEM(state, item) {
    state.items.push(item);
  },
  REMOVE_ITEM(state, id) {
    state.items.splice(state.items.findIndex(item => item.id === id), 1);
  },
  UPDATE_ITEM(state, {id, data}) {
    const index = state.items.findIndex(item => item.id === id);
    
    if (-1 === index) {
      return;
    }

    state.items[index] = Object.assign(state.items[index], data);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
